import { observer } from "mobx-react";
import * as React from "react";

import { ListShockProfiles } from "../ui/molecules/list-shock-profiles";
import { ListCommandButtonsShockProfiles } from "../ui/organisms/list-command-buttons-shock-profiles";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageShockProfiles extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    constructor(props: {}) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.shockProfiles.title")} classic>
                <Section fill>
                    <ListShockProfiles
                        commandBar={
                            <ListCommandButtonsShockProfiles
                                listStateId={this.listStateId}
                                canDelete
                            />
                        }
                        listStateId={this.listStateId}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
